import { CompleteAccountModalContext, ModalContext, openCompleteAccountSignUpModal } from '@/redux/modules/modal';
import { EventContext } from '@/redux/modules/analytics';
import { useAppDispatch } from '@/redux/hooks';
import { useCallback } from 'react';
import { useRequireLogin } from '@/components/ShouldLogIn/hooks/useRequireLogin';

type Props = {
    itemId: number;
};

export const useSeeSoldPrice = ({ itemId }: Props) => {
    const dispatch = useAppDispatch();
    const verifyLogin = useRequireLogin();

    return useCallback(async () => {
        const modalContext: ModalContext = {
            eventContext: EventContext.seeSoldPrice,
            id: itemId,
            itemId,
            type: CompleteAccountModalContext.SeeSoldPrice,
        };

        await verifyLogin({
            modalContext,
            requireLogin: true,
            runFunction: () => dispatch(openCompleteAccountSignUpModal(modalContext)),
        });
    }, [dispatch, itemId, verifyLogin]);
};
